import React, { useState } from 'react';
import MailchimpSubscribe from 'react-mailchimp-subscribe';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

import '../styles/modal.scss';
import Logo from '../assets/icon.png';
import { Modal } from 'react-bootstrap';
import ExitIcon from '../assets/exit.png';

//https://uQuest.us20.list-manage.com/subscribe/post?u=8851c8f761cbcc9e215fa86db&amp;id=8696beeb4c

const MAILCHIMP_URL =
  'https://uQuest.us20.list-manage.com/subscribe/post?u=8851c8f761cbcc9e215fa86db&amp;id=8696beeb4c';

function ModalComponent(props) {
  const [EMAIL, setEmail] = useState();
  const [FNAME, setFName] = useState();
  const [LNAME, setLName] = useState();
  const [SUBMITED, setSubited] = useState(false);

  return (
    <MailchimpSubscribe
      url={MAILCHIMP_URL}
      render={({ subscribe, status, message }) => (
        <Modal
          dialogClassName="ModalDialog"
          {...props}
          show={props.isOpen}
          onHide={() => props.closeModal()}
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Modal.Body className="ModalDialog">
            <div className="modal-exit-container">
              <img
                className="modal-exit"
                onClick={() => props.closeModal()}
                src={ExitIcon}
                alt="ExitIcon"
              />
            </div>
            <div className="containerBlock">
              <div className="headerModal">
                <img src={Logo} alt="Logo" className="logoModal"></img>
                {!SUBMITED && (
                  <div>
                    <p className="joinText">
                      Join to get early access or refer a friend.
                    </p>
                    <div className="containerInputs">
                      <input
                        onChange={({ target }) => setEmail(target.value)}
                        placeholder="Email"
                        className="inputModal"
                      />
                      <input
                        onChange={({ target }) => setFName(target.value)}
                        placeholder="First name"
                        className="inputModal"
                      />
                      <input
                        onChange={({ target }) => setLName(target.value)}
                        placeholder="Last name"
                        className="inputModal"
                      />
                      <button
                        onClick={() => {
                          subscribe({ EMAIL, FNAME, LNAME });
                          ReactGA.ga('send', 'SignUpComplete');
                          ReactPixel.trackCustom('SignUpComplete');
                          setSubited(true);
                        }}
                        className="buttonModal"
                      >
                        Get Early Access
                      </button>
                      <div className="checkboxContainer">
                        <p className="checkboxText">
                          By registering I claim to have read and agree to the{' '}
                          <a href="/terms-conditions" target="blank">
                            {'terms & conditions,'}
                          </a>{' '}
                          <a href="/privacy-policy" target="blank">
                            Privacy Policy
                          </a>{' '}
                          including <br /> our use of Cookies. I am also willing
                          to receive uQuest propaganda, that I can unsubscribe
                          from at any time.
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                {SUBMITED && (
                  <div>
                    <div className="distancer" />
                    <p className="joinText">Thank you for subscribing</p>
                    <p
                      className="addAnother"
                      onClick={() => {
                        setSubited(false);
                        setEmail('');
                        setFName('');
                        setLName('');
                      }}
                    >
                      Add another one
                    </p>
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    />
  );
}

export default ModalComponent;
